import DataTable from 'datatables.net-dt';
import 'datatables.net-responsive-dt';
import 'datatables.net-fixedheader-dt';
import languageFR from 'datatables.net-plugins/i18n/fr-FR.mjs';
import languageES from 'datatables.net-plugins/i18n/es-ES.mjs';
import IsInView from './_isInView';
import A11yMenu from './_a11yMenu';
import FormValidate from './_formValidate';
import Disclosure from './_disclosure';

function ieVersion() {
	const uaString = navigator.userAgent;
	var match = /\b(MSIE |Trident.*?rv:|Edge\/)(\d+)/.exec(uaString);
	if (match) return parseInt(match[2])
}

function initDisclo() {
	// Disclosure
	const disclos = document.querySelectorAll('.disclosure h2');

	disclos.forEach((btn) => {
		const discloItem = new Disclosure(btn);
		discloItem.init();
	});
}


document.addEventListener('DOMContentLoaded', () => {

	document.body.classList.remove('no-js');
	document.body.classList.add('js');

	const ieVer = ieVersion();
	if (ieVer) {
		document.documentElement.classList.add("ie");
		document.documentElement.classList.add("ie-" + ieVer);
	}

	initDisclo();

	// Menu
	const a11yMenus = document.querySelectorAll('.a11y-nav-wrapper');
	a11yMenus.forEach((menu) => {
		const a11yMenuItem = new A11yMenu(menu);
		a11yMenuItem.init();
	});


	// Liste
	if (document.querySelector('.js-table')) {
		const table = document.querySelector('.js-table');

		let lang = languageFR;
		if (document.documentElement.lang == 'es') {
			lang = languageES;
		}

		table.focus();
		table.scrollIntoView(true);

		const $tokN = table.getAttribute('data-tokn');
		const datas = {};
		datas['last_names'] = table.getAttribute('data-last_names');
		datas['first_names'] = table.getAttribute('data-first_names');
		datas['birth_year'] = table.getAttribute('data-birth_year');
		datas['birth_town'] = table.getAttribute('data-birth_town');
		datas['birth_province'] = table.getAttribute('data-birth_province');
		datas['birth_region'] = table.getAttribute('data-birth_region');
		datas['cte_number'] = table.getAttribute('data-cte_number');
		datas['parcours'] = table.getAttribute('data-parcours');
		datas[$tokN] = table.getAttribute('data-tokv');

		new DataTable(table, {
			"pageLength": 20,
			fixedHeader: true,
			processing: true,
			serverSide: true,
			ajax: {
				url: table.getAttribute('data-url') + 'process/',
				type: 'POST',
				data: datas,
			},
			deferLoading: table.getAttribute('data-total'),
			info: false,
			searching: false,
			ordering: true,
			"order": [],
			"autoWidth": false,
			"lengthChange": true,
			responsive: true,
			language: lang
		});
	}
	if (document.querySelector('.searchEmptyMessage')) {
		document.querySelector('.searchEmptyMessage').focus();
		document.querySelector('.searchEmptyMessage').scrollIntoView(true);
	}


	// Summary
	const ifDetection = document.querySelector('.js-scroll-detect');
	if (ifDetection) {
		if ('IntersectionObserver' in window) {
			const checkInView = new IsInView('.js-scroll-detect', false);
			checkInView.init();
		}

		let ticking = false;
		document.addEventListener("scroll", () => {

			if (!ticking) {

				window.requestAnimationFrame(() => {

					let inViewSections = document.querySelectorAll('.js-scroll-detect.is-in-view');

					inViewSections.forEach((elt) => {

						let sep = elt.offsetTop - document.documentElement.scrollTop;

						if (sep <= 100) {

							const cl = "." + elt.id;
							const currentSec = document.querySelector(cl);
							const oldCurrent = document.querySelector('.summary__link[aria-current]');
							if (oldCurrent && (oldCurrent.getAttribute('data-sec') != currentSec.getAttribute('data-sec'))) {
								oldCurrent.removeAttribute('aria-current');
							}
							currentSec.setAttribute('aria-current', true);

						}
					});

					ticking = false;

				});

				ticking = true;

			}
		});
	}

	// goToTop
	const goToTop = document.getElementById('goToTop');
	const media = window.matchMedia('(max-width:40em)');
	const vpH = window.innerHeight;

	let posScroll = 0;
	let tick = false;
	if (media.matches) {
		document.addEventListener("scroll", () => {
			posScroll = window.scrollY;
			if (!tick) {
				window.requestAnimationFrame(() => {
					if (posScroll >= vpH) {
						goToTop.classList.add('visible');
					} else {
						goToTop.classList.remove('visible');
					}
					tick = false;
				});
				tick = true;
			}
		});
	}

	document.addEventListener("scroll", () => {
		posScroll = window.scrollY;
		if (!tick) {
			window.requestAnimationFrame(() => {
				if (posScroll >= vpH) {
					goToTop.classList.add('visible');
				} else {
					goToTop.classList.remove('visible');
				}
				tick = false;
			});
			tick = true;
		}
	});



	// CONTACT
	const domForm = document.querySelector('.js-contactForm');
	if (domForm) {
		new FormValidate(domForm, 'multiple');
	}

	const formResult = document.querySelector('.formResultMessage > .alert');
	if (formResult) {
		window.setTimeout(() => {
			formResult.parentElement.focus();
		}, 100);
	}
});